import { EntityBase } from './entity-base';

/**
 * Represents a lab/exercise entity within a course.
 * @extends EntityBase
 * @class LabEntity
 */
export class LabEntity extends EntityBase {
  /**
   * The lab code or identifier.
   * @type {string}
   * @default ""
   * @example "LAB001", "EXERCISE-01"
   */
  public code: string = "";

  /**
   * The order in which this lab appears in the course sequence.
   * @type {number}
   * @default 0
   * @example 1, 2, 3 (for 1st, 2nd, 3rd lab)
   */
  public labOrder: number = 0;

  /**
   * Detailed description of what the lab covers.
   * @type {string}
   * @default ""
   */
  public description: string = "";

  /**
   * Expected duration to complete the lab in hours.
   * @type {number}
   * @default 0
   * @example 2.5 (for 2 hours and 30 minutes)
   */
  public durationInHours: number = 0;

  /**
   * Indicates whether the lab requires hands-on practice with VMs.
   * @type {boolean}
   * @default false
   */
  public hasHandsOn: boolean = false;

  /**
   * Array of study materials or content items for the lab.
   * @type {string[]}
   * @default []
   * @example ["Introduction to Azure VMs", "Creating a Virtual Machine", "Configuring Networks"]
   */
  public labContents: string[] = [];

  /**
   * URL where the lab study materials are hosted online.
   * @type {string}
   * @default ""
   * @example "https://docs.example.com/labs/lab001"
   */
  public labContentsUrl: string = "";
}
